/** @jsx jsx */
import { jsx } from 'theme-ui';
import { Slide, Swiper as BaseSwiper } from 'react-dynamic-swiper';
import 'react-dynamic-swiper/lib/styles.css';
import * as styles from './Swiper.styles';

export default function Swiper({
  images = [],
  swiperOptions,
  navigation = false,
  pagination = true,
  ...rest
}) {
  return (
    <BaseSwiper
      navigation={navigation}
      pagination={pagination}
      swiperOptions={{ autoplay: { delay: 5000 }, ...swiperOptions }}
      sx={styles.Swiper}
      {...rest}
    >
      {images.map(image => (
        <Slide key={image}>
          <div
            sx={{
              background: 'center center / cover no-repeat',
              backgroundImage: `url(${image})`,
            }}
            style={styles.Slide}
          />
        </Slide>
      ))}
    </BaseSwiper>
  );
}
